module.exports = __webpack_public_path__ + "static/media/en.386cc387.svg";